export interface IMediaItemSizeMenuItem {
    label: string;
    mediaItemClass: string;
}

export const FiTextItemMediaPanelSizeMenuItems: IMediaItemSizeMenuItem[] = [
    {
        label: 'mediaModule.original',
        mediaItemClass: 'fi-text-item-media-item-size-original',
    },
    {
        label: 'common.small',
        mediaItemClass: 'fi-text-item-media-item-size-small',
    },
    {
        label: 'common.medium',
        mediaItemClass: 'fi-text-item-media-item-size-medium',
    },
    {
        label: 'common.large',
        mediaItemClass: 'fi-text-item-media-item-size-large',
    },
];
